import { LocalStorageService } from './../../../utils/local-storage.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OndcConfigComponent } from '../ondc-config/ondc-config.component';
import * as _ from 'lodash';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import constant from '../../../../../src/app/app.constant';
import commonLogics from '../../../utils/common-logic.service';
import { CommonHttpService } from '../../../../../src/app/utils/common-http.service';
import Swal from 'sweetalert2';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { OnlyNumberDirective } from '../../../directives/only-number.directive';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { EmptyStateComponent } from '../../../shared/components/empty-state/empty-state.component';
import { DateTimePickerComponent } from '../../../shared/components/date-time-picker';
interface ApiResponse {
  status: boolean;
  message: string;
  data?: any;
}

@Component({
  selector: 'app-delivery-partner-map',
  templateUrl: './delivery-partner-map.component.html',
  styleUrls: ['./delivery-partner-map.component.scss'],
  standalone: true,
  imports: [NgSelectModule, ReactiveFormsModule, CommonModule, NgbModule, TranslateModule, FormsModule, DragulaModule, OnlyNumberDirective, OndcConfigComponent, EmptyStateComponent, DateTimePickerComponent]
})
export class DeliveryPartnerMapComponent implements OnInit {
  public constant = constant;
  public commonLogics = commonLogics;
  public deliveryPartnerList: any = [];
  deliveryPartnerShow: boolean = true;
  UserDeliveryPartnerMap: any = [];
  dpFormGroup: FormGroup;
  submitted = false;
  dp_rearrange_with_eta: any;
  dp_push_mechanisum: any;
  dp_name: any;
  Math = Math;
  dpList: any = [];
  dp_setup: any;
  apply_dp_setup: any;
  originalApplyDpSetup: any; // Store the original value
  kmValidationErrors: any = {}; // Track validation errors for each delivery partner
  agencyType: any;

  @ViewChild('ondcConfig') ondcConfigComponent!: OndcConfigComponent;

  @Output() dpRearrangEvent = new EventEmitter();
  applydpList: any = [];
  userAgencyType: any;
  deliveryPartnerIds: any = [];
  ondcConfigListData: any = [];
  ondcActiveCheck: boolean = false;
  ondcDelPartnerId: any;
  constructor(private toaster: ToastrService, private router: Router, private dragulaService: DragulaService, public activeModal: NgbActiveModal, private http: CommonHttpService, private _formBuilder: FormBuilder, private localstore: LocalStorageService) {
    this.dragulaService.createGroup("DPM", {
      // removeOnSpill: true
      // On touch screens a drag from anywhere on the card hijacks the finger
      // scroll through the list, so there it starts only from the grip
      // (`.ad-drag`). Mouse users keep drag-from-anywhere.
      moves: (_el?: Element, _container?: Element, handle?: Element) =>
        !window.matchMedia('(pointer: coarse)').matches || !!handle?.closest('.ad-drag'),
    });
  }
  @Input() userData: any;

  // Role of the user whose 3PL map is being edited, sent with every 3PL map write.
  get userRoleId() {
    return this.userData?.role_id;
  }

  ngOnInit() {
    this.dpFormGroup = this._formBuilder.group({
      delivery_partner_user_id: [null, Validators.required],
      waiting_time_in_min: [null, [Validators.required, waitingTimeValidator]],
      // min_km: [null, [Validators.required, waitingTimeValidator]],
      // max_km: [null, [Validators.required, waitingTimeValidator]],
    });

    if (this.userData) {
      let tempDta: any = []
      if (this.userData.ondc_bap_id != null) {
        this.userData.ondc_bap_id.split(',').map((item: any) => { tempDta.push(item.trim()) })
      }
      this.ondcConfigListData = tempDta
      this.dp_rearrange_with_eta = this.userData?.dp_rearrange_with_eta;
      this.dp_push_mechanisum = this.userData?.dp_push_mechanisum;
      this.dpList = this.userData?.dpList;
      this.dp_setup = this.userData?.dp_setup;
      this.apply_dp_setup = this.userData?.apply_dp_setup;
      this.originalApplyDpSetup = this.userData?.apply_dp_setup; // Store original value
      this.applydpList = this.userData?.applydpList;
      this.userAgencyType = this.userData?.userAgencyType;
      this.getDeliveryPartnerDetails();
    }
    this.userData.apply_dp_setup = this.apply_dp_setup
    this.agencyType = this.localstore.getItem(constant.localStorage.agency_type)
  }
  getDeliveryPartnerDetails() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderGetMap + '/' + this.userData?.userId).subscribe((response: any) => {
      if (response.status) {
        var deliveryPartnerList = response?.data?.DeliveryPartner;
        this.UserDeliveryPartnerMap = response?.data?.UserDeliveryPartnerMap;

        if ([constant.RoleId.masterAgency, constant.RoleId.agency, constant.RoleId.vendor].includes(this.localstore.getItem(constant.localStorage.user_role_id)) && this.agencyType == constant.typeOf.agency) {
          deliveryPartnerList?.forEach((item: any) => {
            if (item?.user_id == 1) { item.full_name = 'Own Rider'; }
          });
          this.UserDeliveryPartnerMap?.forEach((element: any) => {
            if (element?.delivery_partner_user_id == 1) { element.DeliveryPartner.full_name = 'Own Rider'; }
          });

        }

        // this.deliveryPartnerIds = response?.data?.UserDeliveryPartnerMap.map((x:any) =>(x.delivery_partner_user_id))
        // this.ondcActiveCheck = response?.data?.UserDeliveryPartnerMap?.some((x: any) =>x.delivery_partner_user_id == constant.deliveryPartnerViaOndc && x.status == 'Active');       
        this.UserDeliveryPartnerMap = (response?.data?.UserDeliveryPartnerMap || [])
          .sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
        if (_.isArray(this.UserDeliveryPartnerMap) && !_.isEmpty(this.UserDeliveryPartnerMap)) {
          this.deliveryPartnerList = [];
          var delivery_partner = [] = this.UserDeliveryPartnerMap?.map((element: any) => {
            if (element?.delivery_partner_user_id) {
              if (element?.delivery_partner_user_id == constant.deliveryPartnerViaOndc) {
                // this.ondcConfigListFun()
              }
              //  this.deliveryPartnerIds.push( element?.delivery_partner_user_id)
              let newDate = moment().format('x');
              element.DeliveryPartner.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + element?.DeliveryPartner.icon_url + '&=' + newDate;
              return element.delivery_partner_user_id;
            }
          })
          deliveryPartnerList?.filter((item: any) => {
            if (!delivery_partner.includes(item.user_id)) {
              this.deliveryPartnerList.push(item);
            };
          });
          this.UserDeliveryPartnerMap?.map((element: any, index: any) => {
            element.previous_json = { ...element };
            // Validate km range for each delivery partner
            this.validateKmRange(index);
          })
        } else {
          this.deliveryPartnerList = [];
          this.deliveryPartnerList = deliveryPartnerList;
        }
      }
    })
  }
  thirdPartyMethod() {
    var reqJson: any = {
      dp_push_mechanisum: this.dp_push_mechanisum,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_push_mechanisum: this.dp_push_mechanisum });

    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  dpSetupMethod() {
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_setup: this.dp_setup });

    // if(this.userData.role_id == constant.RoleId.vendor) 
    if (this.localstore.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
      const vendorReqJson: any = {
        dp_setup: this.dp_setup,

        user_id: this.userData.userId,
      };
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.VendorUpdate, vendorReqJson).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Successfully Updated');
        } else {
          this.toaster.error(response.message);
        }
      });
    } else {
      const reqJson: any = {
        dp_setup: this.dp_setup,
        user_id: this.userData.userId,
        under_user_id: this.userData.under_user_id,
        agency_user_id: this.userData.agency_user_id,
        master_agency_user_id: this.userData.master_agency_user_id,
        vendor_agency_user_id: this.userData.vendor_agency_user_id,
        under_role_id: this.userData.under_role_id,
      };
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Successfully Updated');
        } else {
          this.toaster.error(response.message);
        }
      });
    }
  }

  onApplyDpSetupChange(newValue: any) {
    // Use the stored original value
    const originalValue = this.originalApplyDpSetup;

    // // Temporarily set the new value for the confirmation dialog
    // this.apply_dp_setup = newValue?.value;
    Swal.fire({
      title: 'Apply to All Nested Customers?',
      text: "",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Temporarily set the new value for the confirmation dialog
        this.apply_dp_setup = newValue?.value;
        this.applyDpSetupMethod();

      } else if (result.isDismissed) {
        // User cancelled, revert to original value    
        this.apply_dp_setup = originalValue;
      }
    });
  }
  applyDpSetupMethod() {
    var reqJson: any = {
      apply_dp_setup: this.apply_dp_setup,
      dp_setup: this.dp_setup,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      under_role_id: this.userData.under_role_id,
      role_id: this.userData.role_id,
    }
    this.userData.apply_dp_setup = this.apply_dp_setup; // Update userData with the new value
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.updateDpSetup, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated');
        this.dpRearrangEvent.emit({ user_id: this.userData.userId, apply_dp_setup: this.apply_dp_setup });
        this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_setup: (this.apply_dp_setup == constant.dpSetup.masterAgency || this.apply_dp_setup == constant.dpSetup.agency) ? constant.dpSetup.own : this.apply_dp_setup });
        this.dp_setup = (this.apply_dp_setup == constant.dpSetup.masterAgency || this.apply_dp_setup == constant.dpSetup.agency) ? constant.dpSetup.own : this.apply_dp_setup
        this.originalApplyDpSetup = this.apply_dp_setup;
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  deliveryPartnerAdd() {
    this.deliveryPartnerShow = false;
    this.submitted = false;
    this.dpFormGroup.reset();
  }
  backBtn() {
    this.deliveryPartnerShow = true;
  }
  ngOnDestroy() {
    this.dragulaService.destroy('DPM');
    // Clear validation errors
    this.kmValidationErrors = {};
  }
  closeModal() {
    // Clear validation errors before closing
    this.kmValidationErrors = {};
    this.activeModal.dismiss();
  }

  // editFunction(event: any, i: any, name: any) {
  //   const inputValue = event?.target?.value;

  //   // If empty, allow it (user might be typing)
  //   if (inputValue === '' || inputValue === null || inputValue === undefined) {
  //     return;
  //   }

  //   const value = Number(inputValue);

  //   // Only validate if it's a complete number (not during typing)
  //   if (inputValue.includes('.') || inputValue.includes('e')) {
  //     return; // Allow decimal and scientific notation during typing
  //   }

  //   // Validate the input
  //   if (isNaN(value)) {
  //     // Don't show error immediately, let user finish typing
  //     return;
  //   }

  //   // Update the value if it's valid
  //   if (name == 'waiting_time_in_min') {
  //     if (value >= 0) {
  //       this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = value;
  //     }
  //   }
  //   if (name == 'max_km') {
  //     this.UserDeliveryPartnerMap[i]['max_km'] = value;
  //     // Trigger km validation after updating max_km
  //     setTimeout(() => this.validateKmRange(i), 0);
  //   }
  //   if (name == 'min_km') {
  //     this.UserDeliveryPartnerMap[i]['min_km'] = value;
  //     // Trigger km validation after updating min_km
  //     setTimeout(() => this.validateKmRange(i), 0);
  //   }

  // }
  editFunction(event: any, i: any, name: any) {
    if (event?.target?.value && name == 'waiting_time_in_min') {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = event?.target?.value;
    }
    if (name == 'max_km') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['max_km'] = value;
      // Trigger km validation after updating max_km
      setTimeout(() => this.validateKmRange(i), 0);
    }
    if (name == 'min_km') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['min_km'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);
    }
    if (name == 'max_order_value') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['max_order_value'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);

    }
       if (name == 'push_waiting_time') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['push_waiting_time'] = value === '' || value === null || value === undefined ? null : Number(value);
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);

    }
        if (name == 'allowed_extra_charge') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['allowed_extra_charge'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);

    } if (name == 'start_time') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['start_time'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);

    }
    if (name == 'end_time') {
      const value = event?.target?.value;
      this.UserDeliveryPartnerMap[i]['end_time'] = value;
      // Trigger km validation after updating min_km
      setTimeout(() => this.validateKmRange(i), 0);

    }
  }
  isValidTime(time: string): boolean {
    return /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(time);
  }
  validateWaitingTime(event: any, i: any) {
    const inputValue = event?.target?.value;
    const partnerName = this.UserDeliveryPartnerMap[i]?.DeliveryPartner?.full_name || 'Delivery Partner';

    // If empty, set to default value of 1
    if (inputValue === '' || inputValue === null || inputValue === undefined) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.info(`Waiting time for ${partnerName} set to 1 minute (minimum)`);
      return;
    }

    const value = Number(inputValue);

    // Validate the input
    if (isNaN(value)) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.warning(`Invalid number for ${partnerName}. Set to 1 minute.`);
      return;
    }

    // Handle negative values - convert to positive
    if (value < 0) {
      const positiveValue = Math.abs(value);
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = positiveValue;
      event.target.value = positiveValue;
      this.toaster.info(`Negative value for ${partnerName} converted to ${positiveValue} minutes`);
      return;
    }

    // Handle values less than 1
    if (value < 1) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 1;
      event.target.value = 1;
      this.toaster.info(`Waiting time for ${partnerName} adjusted to minimum (1 minute)`);
      return;
    }

    // Handle values greater than 60
    if (value > 60) {
      this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = 60;
      event.target.value = 60;
      this.toaster.info(`Waiting time for ${partnerName} adjusted to maximum (60 minutes)`);
      return;
    }

    // Update the value if validation passes
    this.UserDeliveryPartnerMap[i]['waiting_time_in_min'] = value;
  }

  validateKmRange(i: any) {
    const minKm = this.UserDeliveryPartnerMap[i]?.min_km;
    const maxKm = this.UserDeliveryPartnerMap[i]?.max_km;
    const order_value = this.UserDeliveryPartnerMap[i]?.max_order_value;
    const push_wait_time = this.UserDeliveryPartnerMap[i]?.push_waiting_time;
    const allowed_extra_charge = this.UserDeliveryPartnerMap[i]?.allowed_extra_charge;
    const start_time = this.UserDeliveryPartnerMap[i]?.start_time;
    const end_time = this.UserDeliveryPartnerMap[i]?.end_time;
    const partnerName = this.UserDeliveryPartnerMap[i]?.DeliveryPartner?.full_name || 'Delivery Partner';

    // Clear previous error for this partner
    this.kmValidationErrors[i] = null;

    // If both values are empty, no validation needed
    if ((minKm === null || minKm === undefined || minKm === '') &&
      (maxKm === null || maxKm === undefined || maxKm === '') &&
      (order_value === null || order_value === undefined || order_value === '') &&
      (push_wait_time === null || push_wait_time === undefined || push_wait_time === '') &&
      (allowed_extra_charge === null || allowed_extra_charge === undefined || allowed_extra_charge === '') &&
      (start_time === null || start_time === undefined || start_time === '') &&
      (end_time === null || end_time === undefined || end_time === '')) {
      return true;
    }

    // Convert to numbers for comparison
    const minKmNum = Number(minKm);
    const maxKmNum = Number(maxKm);
    const order_valueNum = Number(order_value);
    const push_wait_timeNum = Number(push_wait_time);
    const allowed_extra_chargeNum = Number(allowed_extra_charge);

    // Check if min km is a valid number
    if (minKm !== null && minKm !== undefined && minKm !== '' && isNaN(minKmNum)) {
      this.kmValidationErrors[i] = `Min KM must be a valid number for ${partnerName}`;
      return false;
    };
    if (order_value !== null && order_value !== undefined && order_value !== '' && isNaN(order_valueNum)) {
      this.kmValidationErrors[i] = `Order Value must be a valid number for ${partnerName}`;
      return false;
    };
    if (order_value !== null && order_value !== undefined && order_value !== '' && (order_valueNum < 0 || order_valueNum > 10000)) {
      this.kmValidationErrors[i] = `Order Value must be between 0 and 10000 for ${partnerName}`;
      return false;
    }

    if (push_wait_time !== null && push_wait_time !== undefined && push_wait_time !== '' && isNaN(push_wait_timeNum)) {
      this.kmValidationErrors[i] = `Push Wait Time must be a valid number for ${partnerName}`;
      return false;
    };
     if (push_wait_time !== null && push_wait_time !== undefined && push_wait_time !== '' && (push_wait_timeNum < 0 || push_wait_timeNum > 120)) {
      this.kmValidationErrors[i] = `Push Wait Time must be between 0 and 120 for ${partnerName}`;
      return false;
    }

    if (allowed_extra_charge !== null && allowed_extra_charge !== undefined && allowed_extra_charge !== '' && isNaN(allowed_extra_chargeNum)) {
      this.kmValidationErrors[i] = `Allowed Extra Charge must be a valid number for ${partnerName}`;
      return false;
    };

    if (allowed_extra_charge !== null && allowed_extra_charge !== undefined && allowed_extra_charge !== '' && (allowed_extra_chargeNum < 0 || allowed_extra_chargeNum > 100)) {
      this.kmValidationErrors[i] = `Allowed Extra Charge must be between 0 and 100 for ${partnerName}`;
      return false;
    }
    // Check if min km is a not 0 
    // if (minKm !== null && minKm == "'") {
    //   this.kmValidationErrors[i] = `Min KM must be greater then 0  for ${partnerName}`;
    //   return false;
    // };

    // Check if min km is a not 5 
    if (minKm !== null && minKm > 5) {
      this.kmValidationErrors[i] = `Min KM must be not greater then 5  for ${partnerName}`;
      return false;
    };

    // Check if max km is a not 50 
    if (maxKm !== null && maxKm > 50) {
      this.kmValidationErrors[i] = `Min KM must be not greater then 50  for ${partnerName}`;
      return false;
    };

    // Check if max km is a valid number
    if (maxKm !== null && maxKm !== undefined && maxKm !== '' && isNaN(maxKmNum)) {
      this.kmValidationErrors[i] = `Max KM must be a valid number for ${partnerName}`;
      return false;
    }

    // If one time is set, the other must also be set
    if (start_time && !end_time) {
      this.kmValidationErrors[i] = `End Time is required when Start Time is set for ${partnerName}`;
      return false;
    }
    if (end_time && !start_time) {
      this.kmValidationErrors[i] = `Start Time is required when End Time is set for ${partnerName}`;
      return false;
    }
    // Compare in IST to avoid UTC midnight-crossing false positives
    const start_time_ist = start_time ? this.utcToIst(start_time) : null;
    const end_time_ist = end_time ? this.utcToIst(end_time) : null;

    // Check if start_time and end_time are the same
    if (start_time_ist && end_time_ist && start_time_ist === end_time_ist) {
      this.kmValidationErrors[i] = `Start Time and End Time cannot be the same for ${partnerName}`;
      return false;
    }
    // Check if end_time is not after start_time
    if (start_time_ist && end_time_ist && end_time_ist <= start_time_ist) {
      this.kmValidationErrors[i] = `End Time must be after Start Time for ${partnerName}`;
      return false;
    }
    // Only validate if both values are present and valid numbers
    if (!isNaN(minKmNum) && !isNaN(maxKmNum)) {
      // Check if min km is greater than max km
      if (minKmNum > maxKmNum) {
        this.kmValidationErrors[i] = `Min KM (${minKmNum}) cannot be greater than Max KM (${maxKmNum}) for ${partnerName}`;
        return false;
      }
    }

    return true;
  }

  validateAllKmRanges() {
    let hasErrors = false;
    for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
      if (!this.validateKmRange(i)) {
        hasErrors = true;
      }
    }
    return !hasErrors;
  }

  interChangeList(item: any) {
    var changeItem = [] = item;
    this.UserDeliveryPartnerMap = [...changeItem];

    // Revalidate km ranges after reordering
    this.UserDeliveryPartnerMap.forEach((element: any, index: any) => {
      this.validateKmRange(index);
    });

    this.checkPushWaitTimeOrder();
  }

  // Dragging can put a delivery partner with a higher Push Wait Time above
  // one with a lower value. Since sortActiveByPushWaitTime() re-slots Active
  // entries ascending by push_waiting_time on Update, warn the user that the
  // visual order they just dragged won't stick.
  checkPushWaitTimeOrder() {
    if (this.dp_push_mechanisum !== 'Parallel') { return; }

    const activeItems = this.UserDeliveryPartnerMap.filter((item: any) => item.status === 'Active');
    for (let i = 0; i < activeItems.length - 1; i++) {
      const current = activeItems[i];
      const next = activeItems[i + 1];
      const currentWait = Number(current.push_waiting_time) || 0;
      const nextWait = Number(next.push_waiting_time) || 0;
      if (currentWait > nextWait) {
        const currentName = current?.DeliveryPartner?.full_name || 'Delivery Partner';
        const nextName = next?.DeliveryPartner?.full_name || 'Delivery Partner';
        this.toaster.info(
          `${currentName} (${currentWait} min) is currently below ${nextName} (${nextWait} min). The delivery partners will be automatically reordered by Push Wait Time on Update.`,
          '',
          { timeOut: 6000, extendedTimeOut: 2000 }
        );
        return;
      }
    }
  }

  // Manual drag reordering isn't offered any more - order is driven by Push
  // Wait Time. Re-slots only the Active entries among themselves, ascending
  // by push_waiting_time; InActive entries stay at their current index.
  sortActiveByPushWaitTime(list: any[]) {
    const activeIndices: number[] = [];
    const activeItems: any[] = [];
    list.forEach((item: any, index: number) => {
      if (item.status === 'Active') {
        activeIndices.push(index);
        activeItems.push(item);
      }
    });
    activeItems.sort((a: any, b: any) => (Number(a.push_waiting_time) || 0) - (Number(b.push_waiting_time) || 0));
    activeIndices.forEach((index: number, i: number) => {
      list[index] = activeItems[i];
    });
  }

  addDeliveryPartner() {
    this.submitted = true;
    if (this.dpFormGroup.valid) {
      var reqData: any = [{
        delivery_partner_user_id: this.dpFormGroup.value.delivery_partner_user_id,
        user_id: this.userData.userId,
        waiting_time_in_min: this.dpFormGroup.value.waiting_time_in_min,
        master_agency_user_id: this.userData.master_agency_user_id,
        agency_user_id: this.userData.agency_user_id,
        full_name: this.userData.fullName,
        dp_name: this.dp_name,
        status: "Active",
        sort_order: null,
        user_role_id: this.userRoleId,
      }]
      if (this.UserDeliveryPartnerMap) {
        reqData[0].sort_order = this.UserDeliveryPartnerMap.length + 1
      } else {
        reqData[0].sort_order = 1;
      };
      if (!this.validateAllKmRanges()) {
        // Find the first error and show it
        for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
          if (this.kmValidationErrors[i]) {
            this.toaster.error(this.kmValidationErrors[i]);
            break;
          }
        }
        return;
      }
      this.UserDeliveryPartnerMap.forEach((item: any) => {
        if (_.isEmpty(item.min_km)) { item.min_km = null };
        if (_.isEmpty(item.max_km)) { item.max_km = null };
        if (_.isEmpty(item.max_order_value)) { item.max_order_value = null };
        if (_.isEmpty(item.allowed_extra_charge)) { item.allowed_extra_charge = null };
        if (this.dp_push_mechanisum === 'Parallel') {
          if (item.push_waiting_time === null || item.push_waiting_time === undefined || item.push_waiting_time === '') { item.push_waiting_time = null };
        } else {
          delete item.push_waiting_time;
        }
      });
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, reqData).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Delivery partner added successfully');
          this.dp_name = null;
          this.submitted = false;
          this.deliveryPartnerShow = true;
          this.getDeliveryPartnerDetails();
        } else {
          this.toaster.error(response.message || 'Failed to add delivery partner');
        }
      })
    }
  }
  thirdPartyname(event: any) {
    this.dp_name = event.full_name;
    if (this.dp_push_mechanisum == 'Parallel') {
      this.dpFormGroup.get('waiting_time_in_min')?.setValue(1);
    }
  }
  checkValue(event: any) {
    var reqJson: any = {
      dp_rearrange_with_eta: this.dp_rearrange_with_eta,
      user_id: this.userData.userId,
      under_user_id: this.userData.under_user_id,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      vendor_agency_user_id: this.userData.vendor_agency_user_id,
      under_role_id: this.userData.under_role_id,
    }
    this.dpRearrangEvent.emit({ user_id: this.userData.userId, dp_rearrange_with_eta: this.dp_rearrange_with_eta });
    // if (event.target.checked) reqJson.dp_rearrange_with_eta = this.dp_rearrange_with_eta;
    this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully Updated')
      } else {
        this.toaster.error(response.message)
      }
    });
  }
  allowCod(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].allow_cod = event?.target?.checked;
    // this.updateData();
  }
  activeAndInactive(event: any, i: any) {
    this.UserDeliveryPartnerMap[i].status = (event?.target?.checked) ? 'Active' : 'InActive';
    // if(this.UserDeliveryPartnerMap[i].delivery_partner_user_id == constant.deliveryPartnerViaOndc){
    //   this.ondcActiveCheck = (event?.target?.checked) ? true : false;
    // }
    var removeItem = {}
    if (!event.target.checked) {
      this.UserDeliveryPartnerMap.forEach((element: any, index: any) => {
        if (index == i) {
          removeItem = element;
          this.UserDeliveryPartnerMap.splice(index, 1)
        };
      });
      this.UserDeliveryPartnerMap.push(removeItem);
    }
    // this.updateData();
  }

  updateData(ondcConfig?: any) {
    var requiredWaitingTime: boolean = true;

    // Validate all km ranges first
    if (!this.validateAllKmRanges()) {
      // Find the first error and show it
      for (let i = 0; i < this.UserDeliveryPartnerMap.length; i++) {
        if (this.kmValidationErrors[i]) {
          this.toaster.error(this.kmValidationErrors[i]);
          break;
        }
      }
      return;
    }

    this.sortActiveByPushWaitTime(this.UserDeliveryPartnerMap);
    this.UserDeliveryPartnerMap.map((item: any, i: any) => {
      item.master_agency_user_id = this.userData.master_agency_user_id,
        item.agency_user_id = this.userData.agency_user_id,
        item.full_name = this.userData.fullName,
        item.sort_order = i + 1
      if (!Number(item?.waiting_time_in_min) && item.status == 'Active') {
        this.toaster.error(`Please fill waiting time for ${item?.DeliveryPartner?.full_name}`);
        return requiredWaitingTime = false;
      } else if (!item?.waiting_time_in_min) {
        item.waiting_time_in_min = 1;
      }
      return item;
    });
    this.UserDeliveryPartnerMap.forEach((item: any) => {
      if (_.isEmpty(item.min_km)) { item.min_km = null };
      if (_.isEmpty(item.max_km)) { item.max_km = null };
      if (_.isEmpty(item.max_order_value)) { item.max_order_value = null };
      if (_.isEmpty(item.allowed_extra_charge)) { item.allowed_extra_charge = null };
      if (this.dp_push_mechanisum === 'Parallel') {
        if (item.push_waiting_time === null || item.push_waiting_time === undefined || item.push_waiting_time === '') { item.push_waiting_time = null };
      } else {
        delete item.push_waiting_time;
      }
    });
    let sendparam: any = {}
    if (requiredWaitingTime) {
      if (ondcConfig) {
        sendparam.ondc_3pl_config = ondcConfig.ondc_3pl_config
        sendparam.ondc_3pl_config.type = "ondc_config_update";
        sendparam.user_id = this.userData.userId;
        sendparam.partners = this.UserDeliveryPartnerMap;
      }
      if (!ondcConfig) {
        sendparam = this.UserDeliveryPartnerMap
      }
      this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DpOrderMap, this.UserDeliveryPartnerMap.map((item: any) => ({ ...item, user_role_id: this.userRoleId }))).subscribe((response: any) => {
        if (response.status) {
          if (ondcConfig) {
            let ondcUrls = ondcConfig.ondc_3pl_config.map((x: any) => x.name);
            this.dpRearrangEvent.emit({ ondc_bap_id: ondcUrls.toString(',') });
            ondcConfig.modalRef?.dismiss();
          }
          this.UserDeliveryPartnerMap?.map((element: any) => {
            delete element.previous_json;
            element.previous_json = { ...element };
          })
          this.toaster.success(response.message)
        }
      })
    }
  }
  deleteDeliveryPartner(event: any, index: any) {
    Swal.fire({
      title: 'Would you like to remove the delivery partner?',
      text: "",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear validation error for this index
        delete this.kmValidationErrors[index];

        let Url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.DeleteDp + '?delivery_partner_user_id=' + event.delivery_partner_user_id + '&vendor_user_id=' + this.userData.userId + '&dp_name=' + event.DeliveryPartner.full_name + '&full_name=' + this.userData.fullName + '&user_role_id=' + this.userRoleId
        if (this.userData?.agency_user_id) {
          Url += '&agency_user_id=' + this.userData?.agency_user_id
        }
        if (this.userData?.master_agency_user_id) {
          Url += '&master_agency_user_id=' + this.userData?.master_agency_user_id
        }
        this.http.deleteDataParams(Url).subscribe((response: any) => {
          if (response.status) {
            // if(constant.deliveryPartnerViaOndc==event.delivery_partner_user_id&&this.ondcActiveCheck){
            //   this.ondcConfigListData = [];
            //   this.userData.ondc_bap_id="";
            // }
            this.toaster.success(response.message);
            this.getDeliveryPartnerDetails();
          }
        })
      }
    })
  }

  // ── ONDC Modal Methods ─────────────────────────────────────────────────
  openOndcPopup(dp: any, index: number) {
    this.ondcDelPartnerId = dp.delivery_partner_user_id
    console.log(dp);

    this.ondcConfigComponent.openOndcPopup(dp, index);
  }

  onOndcSaved(event: { ondc_3pl_config: any[]; ondc_provider_config: any[]; modalRef: any }) {
    let param = {
      map_type: this.apply_dp_setup,
      user_role_id: this.userRoleId,
      // status: this.ondcActiveCheck ? 'Active' : 'InActive',
      user_id: this.userData.userId,
      agency_user_id: this.userData.agency_user_id,
      master_agency_user_id: this.userData.master_agency_user_id,
      delivery_partner_user_id: this.ondcDelPartnerId,
      lsp_list: event.ondc_provider_config
    }
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.DeliveryPartnerWiseOrderTime.ondcupdate, param).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully updated');
        // this.getDeliveryPartnerDetails();
        this.ondcConfigComponent.closeOndcPopup();
      } else {
        this.toaster.error(response.message || 'Failed to update ONDC configuration');
      }
    })
  }
  // ── End of ONDC Modal Methods ─────────────────────────────────────────

  changeToOwnSetup() {
    // Find the Own option in dpList
    console.log("dp_setup", this.dp_setup);
    console.log("dpList", this.dpList);
    const ownOption = this.dpList.find((item: any) => item.value === constant.dpSetup.own);
    if (ownOption) {
      this.dp_setup = constant.dpSetup.own;
      // this.apply_dp_setup = constant.dpSetup.own;
      this.dpSetupMethod(); // This will trigger the API call to update the setup
      this.toaster.info('Switching to Own setup...');
    } else {
      this.toaster.error('Own setup option not available');
    }
  }
  utcToIst(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes + 330;
    const istHours = Math.floor(totalMinutes / 60) % 24;
    const istMinutes = totalMinutes % 60;
    return `${String(istHours).padStart(2, '0')}:${String(istMinutes).padStart(2, '0')}`;
  }

  istToUtc(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    let totalMinutes = hours * 60 + minutes - 330;
    if (totalMinutes < 0) totalMinutes += 24 * 60;
    const utcHours = Math.floor(totalMinutes / 60) % 24;
    const utcMinutes = totalMinutes % 60;
    return `${String(utcHours).padStart(2, '0')}:${String(utcMinutes).padStart(2, '0')}`;
  }

  customerCluster() {
    // Same tab, via the router - not `window.open(..., '_blank')`, which spawned a
    // second tab and a second copy of the app. The cluster view is an ordinary
    // route, so the router reaches it directly; that also drops the hand-rolled
    // `/app` vs `/child` origin juggling, since the base href already accounts for
    // it and only a raw URL string needed to.
    //
    // The modal is dismissed first: it is the topmost layer and would otherwise
    // stay open on top of the page we just navigated to. The cluster page carries
    // a Back button that returns here.
    this.activeModal.dismiss();
    this.router.navigate(['/settings/clustercustomerwise'], {
      queryParams: { id: this.userData.userId, role_id: this.userData.role_id }
    });
  }
}
// Add waitingTimeValidator before the component class
function waitingTimeValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  // Check if value is null or undefined
  if (value === null || value === undefined || value === '') {
    return { required: true };
  }

  // Convert to number
  const numValue = Number(value);

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return { invalidNumber: true };
  }

  // Check if it's negative
  if (numValue < 0) {
    return { negativeValue: true };
  }

  // Check if it's less than 1 or greater than 60
  if (numValue < 1 || numValue > 60) {
    return { outOfRange: true };
  }

  return null;
}